export default __webpack_public_path__ + "static/media/shoes_balenciaga.9992e508.png";